/**
 * Цвета графиков ПРЦ. В теме (`shared/theme/tokens.ts`) палитры для данных
 * пока нет, поэтому она собрана здесь, в одном месте, — кандидат в общие токены.
 *
 * Значения — проверенная палитра dataviz, прогнанная валидатором против
 * поверхностей ОСНОВЫ: светлая — на #FFFDFA (`backgroundElevated`), тёмная — на
 * #1A1A1A (серые фоны тёмной темы с 26.10.2026; на прежних #FFFFFF, #1A1A1D и
 * #1D1713 контраст был тот же ±0,1). Три линии безубыточности проходят попарную проверку (все пары, CVD
 * ΔE ≥ 9,2); у светлой бирюзы контраст 2,8:1 — поэтому на графике подписи
 * концов линий и таблица рядом. Пара «рост / снижение» — синий и красный
 * полюса, ΔE ≥ 19 при дальтонизме.
 */
import type { DefaultTheme } from 'styled-components';

export interface PrcChartColors {
  /** Выручка. */
  revenue: string;
  /** Общие затраты. */
  total: string;
  /** Результат (прибыль или убыток). */
  result: string;
  /** Статья подорожала — тянет цену вверх. */
  up: string;
  /** Статья подешевела. */
  down: string;
}

const LIGHT: PrcChartColors = {
  revenue: '#2a78d6',
  total: '#eb6834',
  result: '#1baf7a',
  up: '#e34948',
  down: '#2a78d6',
};

const DARK: PrcChartColors = {
  revenue: '#3987e5',
  total: '#d95926',
  result: '#199e70',
  up: '#e66767',
  down: '#3987e5',
};

export function prcChartColors(theme: DefaultTheme): PrcChartColors {
  return theme.name === 'dark' ? DARK : LIGHT;
}
